export const stripHtmlAndCleanText = (htmlString: string): string => {
  if (!htmlString) return '';

  // Remove leading/trailing <p>&nbsp;</p> (with optional whitespace/newlines)
  const cleaned = htmlString
    .replace(/^(?:\s*<p>(&nbsp;|\s)*<\/p>\s*)+/gi, '')
    .replace(/(?:\s*<p>(&nbsp;|\s)*<\/p>\s*)+$/gi, '');

  return cleaned
    // Remove HTML tags
    .replace(/<[^>]*>/g, '')
    // Replace HTML entities
    .replace(/&nbsp;/g, ' ')
    .replace(/&mdash;/g, '—')
    .replace(/&ndash;/g, '–')
    .replace(/&#45;/g, '-')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    // Remove newline characters and extra whitespace
    .replace(/\n/g, ' ')
    .replace(/\r/g, ' ')
    .replace(/\t/g, ' ')
    // Replace multiple spaces with single space
    .replace(/\s+/g, ' ')
    // Trim leading and trailing whitespace
    .trim();
};

export const stripWrappingNbsp = (htmlString: string): string => {
  if (!htmlString) return '';

  // Remove leading/trailing <p>&nbsp;</p> (with optional whitespace/newlines)
  const cleaned = htmlString
    .replace(/^(?:\s*<p[^>]*>(&nbsp;|\s)*<\/p>\s*)+/gi, '')
    .replace(/(?:\s*<p[^>]*>(&nbsp;|\s)*<\/p>\s*)+$/gi, '');

  // Remove all whitespace (spaces, tabs, newlines) to check if anything remains
  if (cleaned.replace(/\s/g, '') === '') {
    return '';
  }

  return cleaned;
};
